<template>
  <VDialog v-model="dialog" width="600px">
    <VCard>
      <VBtn absolute style="right: 0" class="mt-1" icon @click="close">
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardText>
        <VList dense class="pt-0">
          <VListItem class="px-0 pt-0">
            <VListItemContent>
              <VListItemTitle class="mt-2">
                {{ $t("productName") }} : {{ data.productName }}</VListItemTitle
              >
              <VListItemTitle class="mt-2"
                >{{ $t("count") }} : {{ data.count }}</VListItemTitle
              >
              <VListItemTitle class="mt-2"
                >{{ $t("productGroup") }}:
                {{ data.productGroupName }}</VListItemTitle
              >
              <VListItemTitle class="mt-2"
                >{{ $t("typeProduct") }}:
                {{ data.productTypeName }}</VListItemTitle
              >
            </VListItemContent>
          </VListItem>
        </VList>
        <VBtn
          color="success"
          width="100%"
          class="mb-3"
          @click="receiveProduct(data.count, true)"
          >{{ $t("receive") }}</VBtn
        >

        <div class="text-center">
          <VMenu
            :close-on-content-click="false"
            max-width="250px"
            nudge-right="150"
            top
            v-model="openMenu"
          >
            <template v-slot:activator="{ on, attrs }">
              <VBtn color="error" width="100%" v-bind="attrs" v-on="on">
                {{ $t("toWriteOff") }}
              </VBtn>
            </template>
            <VCard>
              <VBtn
                absolute
                right
                class="mt-n2"
                style="right: -6px"
                icon
                @click="openMenu = false"
              >
                <VIcon>mdi-close</VIcon>
              </VBtn>
              <VCardText>
                <ValidationObserver v-slot="{ handleSubmit }" ref="formObs">
                  <form
                    @submit.prevent="
                      handleSubmit(() => receiveProduct(writeOffCount, false))
                    "
                  >
                    <div class="py-2">
                      <CustomInputText
                        :name="$t('enterQuantity')"
                        :placeholder="$t('enterQuantity')"
                        :rules="{
                          required: true,
                          max_value: data.count,
                        }"
                        v-model="writeOffCount"
                        ref="writeOffInput"
                        class="user_input no-margin"
                      ></CustomInputText>
                    </div>
                    <VBtn
                      type="submit"
                      color="success"
                      width="100%"
                      class="mb-3 mt-3"
                      >{{ $t("send") }}</VBtn
                    >
                  </form>
                </ValidationObserver>
              </VCardText>
            </VCard>
          </VMenu>
        </div>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  name: "inventarizationDialog",
  data() {
    return {
      dialog: false,
      openMenu: false,
      data: {},
      inventarizationId: null,
      writeOffCount: null,
    };
  },
  watch: {
    openMenu(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.writeOffInput.focus();
          }, 500);
        });
      }
    },
  },
  methods: {
    open(data, inventarizationId) {
      this.dialog = true;
      this.data = { ...data };
      this.inventarizationId = inventarizationId;
    },
    async receiveProduct(count, valid) {
      this.showLoading();
      try {
        let params = {
          count: count,
          inventarizationId: this.inventarizationId,
          productItemId: this.data.id,
          valid: valid,
        };
        await this.$http.post("inventarization-log/save", params);
        this.clearAndAddTable(valid);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    clearAndAddTable(type) {
      this.close();
      this.$emit("clearAndAddTable", type, this.writeOffCount);
      this.writeOffCount = null;
      if (this.$refs.formObs) {
        this.$refs.formObs.reset();
      }
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
